import { render, staticRenderFns } from "./2022-app-qnr.vue?vue&type=template&id=0d0dc52c&scoped=true&"
import script from "./2022-app-qnr.vue?vue&type=script&lang=js&"
export * from "./2022-app-qnr.vue?vue&type=script&lang=js&"
import style0 from "./2022-app-qnr.vue?vue&type=style&index=0&id=0d0dc52c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d0dc52c",
  null
  
)

export default component.exports